import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  MenuItem,
  Typography
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { pathOr } from "ramda";
import SkeletonShell from '../../components/Skeleton';
import { updateBaseUrl } from "../../store/actions/config.actions";
import useStyles from "./styles";
import { api, auth } from "../../common/api-utils";
// import Link from '@material-ui/core/Link';
import { Link } from "react-router-dom";

import {
    forgot,
    getMetaAssets,
  } from "../../store/actions/auth.actions";
const getFaviconEl = () => document.getElementById("favicon");


const ForgotPassword = ({urldata,setIsForgot}) => {

console.log("urlData",urldata)
  const [username, setUsername] = useState("");
  // const [agentCode, setAgentCode] = useState("");
    const [useremail, setEmail] = useState("");
    const [logo, setLogo] = useState("");
    const [url, setUrl] = useState(process.env.REACT_APP_BASE_URL);  
    const [errorshow ,setErrorShow] = useState({});  
    const classes = useStyles();
    const dispatch = useDispatch();
    // useEffect(() => {
    //   const getUrl = async () => {
    //     try {
    //       if(urldata.urldata == ""){
    //         setUrl(process.env.REACT_APP_BASE_URL);
    //       }else{
    //         setUrl(urldata.urldata); 
    //       }
    //     } catch (ex) {
    //       console.log(ex);
    //     }
    //   };
    //   getUrl();
    // }, []);
    // useEffect(() => {
    //     const getLogos = async () => {
    //       try {
    //         const validateLoginParams={params:{'authId': '','accessToken':''},'verify_URL':process.env.REACT_APP_VERIFY_URL};
    //         dispatch(getMetaAssets(validateLoginParams)).then(function(res){
    //         const faviconEl = getFaviconEl();
    //         if (pathOr(undefined, ["data", "logo_icon"], res)) {
    //           localStorage.setItem("favicon", res.data.logo_icon);
    //         }
    //         faviconEl.href = res.data.logo_icon;
    //         setLogo(res.data.logo_image);
    //       })
    //       } catch (ex) {
    //         console.log(ex);
    //       }
    //     };
    //     getLogos();
    //   }, []);

    const onSubmit = async (e) => {
        e.preventDefault();
        const payload = {
          username,
          // agentCode,
          useremail,
          emailurl:window.location.href,
          messagingURL:process.env.REACT_APP_MESSAGING_URL,
          basicAuthorization:process.env.REACT_APP_MESSAGING_Basic_Authorization,
        };
        const isValid = formValidation(payload);
        console.log(isValid);
        setErrorShow(isValid.errors);
        if(isValid.formIsValid){
          dispatch(forgot(payload)).then((res)=>{
            console.log("forgot res ",res);
          });
        }
      };
    const formValidation = (payload) => {
      console.log(payload,"payload");
        let requiredTxt = 'Missing Required Field:';
        let invalidTxt = 'Invalid Value: ';
        let errors = {};
        let formIsValid = true;
        if(payload['useremail'] && payload['useremail'].trim())
					{
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(payload['useremail'])) {
              formIsValid = false;
              errors["email"] = "Please enter valid email address.";
            }
						
					}
	        return { formIsValid: formIsValid, errors: errors };

      }
    // const setBaseUrl = (e) => {
    //   dispatch(updateBaseUrl(e.target.value));
    //   auth.setBaseURL(e.target.value);
    //   api.setBaseURL(e.target.value);
    //   setUrl(e.target.value);
    // };
  return (
    <div >
        <form onSubmit={onSubmit}>
        <Typography
                variant="h6"
                weight="medium"
               className={classes.titleforgot}>Forgot Password</Typography>
         
          <>
            <TextField
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              margin="normal"
              placeholder="Username"
              type="username"
              className={classes.formField}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
            />
                        {/* <TextField
              id="agentCode"
              value={agentCode}
              onChange={(e) => setAgentCode(e.target.value)}
              margin="normal"
              placeholder="Agent Code"
              type="agentCode"
              className={classes.formField}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
            /> */}
            <TextField
              id="email"
              value={useremail}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              placeholder="Email"
              type="email"
              className={classes.formField}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
            />
            <span style={{color:"red"}}>{errorshow['email']}</span>

              <Button
                type="submit"
                //onClick={onSubmit}
                variant="contained"
                color="primary"
                size="large"
                disabled={!username.length || !useremail.length}
                className={classes.formField}
              >
                    Submit
              </Button>
              <div className={classes.linkBox}>
                <Link to={`#`} className={classes.fixedCenter} onClick={() => setIsForgot(false)} variant="body2">
                     Login
                  </Link>
                  </div>
              </>
          </form>
    </div>
  );
};

export default ForgotPassword;
